import request from '@/utils/request'
export async function getUser () {
    return await request.post('/api/sysUserModel/selectGw')
}

// getNews().then(res => {
//     console.log(res)
// })